"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeQueryString = void 0;
var tslib_1 = require("tslib");
var queryString = require("query-string");
var NO_INDEX = -1;
function parseKeysFromString(queryString) {
    return queryString.split('&').map(function (pair) { return pair.split('=')[0]; });
}
var mergeQueryString = function (query, params, filterQueryParams) {
    var initialOrder = parseKeysFromString(query.charAt(0) === '?' ? query.slice(1) : query);
    var queryObj = queryString.parse(query);
    var paramObj = typeof params === 'string' ? queryString.parse(params) : params;
    if (filterQueryParams) {
        Object.keys(queryObj).forEach(function (key) {
            if (!filterQueryParams(key)) {
                delete queryObj[key];
            }
        });
    }
    var result = queryString.stringify(tslib_1.__assign(tslib_1.__assign({}, queryObj), paramObj), {
        sort: function (a, b) {
            var indexA = initialOrder.indexOf(a);
            var indexB = initialOrder.indexOf(b);
            if (indexA === NO_INDEX) {
                return 1;
            }
            if (indexB === NO_INDEX) {
                return NO_INDEX;
            }
            return indexA - indexB;
        },
    });
    return result;
};
exports.mergeQueryString = mergeQueryString;
//# sourceMappingURL=merge-query-string.js.map